<template>
  <div v-if="!isError">
    <dashboard-template>
      <template slot="dashboard-header">
        <div class="dashboard-content w-100">
          <div class="d-flex justify-content-between mb-2">
            <div class="d-flex">
              <h6 class="mb-1">{{ $route.meta.heading }} <span v-if="editedFeed.name !== ''">- {{ editedFeed.name }}</span></h6>
              <img v-if="type !== null && type !== undefined" :src="type.imageUrl" class="ml-4" height="22" width="22" />
            </div>
            <div>
              <h6 class="mb-0">{{$t('feeds.edit')}} {{ editedFeed.id }}</h6>
            </div>
          </div>
        </div>
      </template>
      <template slot="dashboard-body">
        <div class="dashboard-content feed-menu-container">
          <div class="feed-navbar feed-navbar-edit">
            <p class="text-gray-text mb-0 mr-5">{{ $t('feeds.main_settings') }}</p>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.edit.field-mapping' }">{{ $t('feeds.field_mapping') }}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.edit.rules' }">{{$t('feeds.rules')}}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.edit.filters' }">{{$t('feeds.filters')}}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.edit.tagging' }">{{ $t('feeds.tagging') }}</span>
            <img v-bind:src="'/app/images/icons/arrow.svg'" />
            <span v-bind:class="{ active: this.$route.name === 'feed.edit.preview' }">{{ $t('global.preview') }}</span>
          </div>
        </div>
        <router-view :key="$route.path" :feed="editedFeed" :products="$attrs.project.products" :project="$attrs.project"></router-view>
      </template>
    </dashboard-template>
  </div>
  <div v-else>
    <dashboard-template>
      <template slot="dashboard-body">
        <div class="dashboard-content p-5">
          <div class="alert alert-danger mb-5 d-flex align-items-center" role="alert">
            <img width="40" height="40" src="/app/images/icons/warning_danger.svg" class="mr-4" />
            <div v-if="isError404">
              <p class="mb-0">{{ $t('feeds.feed_not_found') }}</p>
            </div>
            <div v-else-if="isErrorProducts">
              <p class="mb-0">{{ $t('feeds.feed_cannot_edit_title') }}</p>
            </div>
          </div>
          <router-link :to="{ name: 'feeds', params: { id: $route.params.projectId }}">
            <button type="button" class="btn btn-large btn-orange">
              <corner-down-left-icon></corner-down-left-icon>
              <span>{{ $t('feeds.feed_list_return') }}</span>
            </button>
          </router-link>
        </div>
      </template>
    </dashboard-template>
  </div>
</template>

<script>
import DashboardTemplate from '@/views/Dashboard'
import axios from 'axios'
import { CornerDownLeftIcon } from 'vue-feather-icons'

export default {
  name: 'FeedEdit',

  data () {
    return {
      editedFeed: {},
      isError404: false,
      isErrorProducts: false,
      type: null
    }
  },

  props: {
    feed: { required: false, type: Object }
  },

  created () {
    const matchingFeed = this.$attrs.project.feeds.filter(feed => feed.id === this.$attrs.feedId)
    if (matchingFeed.length > 0) {
      if (this.feed === undefined) this.editedFeed = this.$attrs.project.feeds.filter(feed => feed.id === this.$attrs.feedId)[0]
      else this.editedFeed = this.feed
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/feed/template/' + this.editedFeed.feedType)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.type = response.data
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
      if (this.$attrs.project.products.length === 0) {
        this.isErrorProducts = true
      }
    } else {
      this.isError404 = true
    }
  },

  computed: {
    isError () {
      if (this.isError404 || this.isErrorProducts) return true
      else return false
    }
  },

  components: { DashboardTemplate, CornerDownLeftIcon }
}
</script>
